// Debug initialization
console.log('Calculator script loading...');

// Product Configuration Objects
const PRODUCTS = {
    tshirts: {
        name: 'T-Shirt',
        image: 'https://cdn.shopify.com/s/files/1/0677/4325/2769/files/tshirt.png?v=1737309791',
        vendor: 'ZERO TO ONE STORE',
        materials: [
            '220 GSM Cotton-Terry',
            '240 GSM Cotton-Terry',
            '240 GSM PC-Terry'
        ],
        minQuantity: 30,
        printingNote: 'For orders between 30-49 pieces, only DTF Printing is available.'
    },
    hoodies: {
        name: 'Hoodie',
        image: 'https://cdn.shopify.com/s/files/1/0677/4325/2769/files/hoodie.png?v=1737309518',
        vendor: 'ZERO TO ONE STORE',
        materials: [
            '350 GSM Cotton-Fleece',
            '420 GSM Cotton-Fleece'
        ],
        minQuantity: 30,
        printingNote: 'Minimum order quantity is strictly 30 pieces.'
    },
    quarterzips: {
        name: 'Quarter-Zip',
        image: 'https://cdn.shopify.com/s/files/1/0677/4325/2769/files/Quarter-Zip.png?v=1737307168',
        vendor: 'ZERO TO ONE STORE',
        materials: [
            '350 GSM Cotton-Fleece',
            '420 GSM Cotton-Fleece'
        ],
        minQuantity: 30,
        printingNote: 'Minimum order quantity is strictly 30 pieces.'
    },
    zippers: {
        name: 'Zipper',
        image: 'https://cdn.shopify.com/s/files/1/0677/4325/2769/files/Zipper.png?v=1737309268',
        vendor: 'ZERO TO ONE STORE',
        materials: [
            '350 GSM Cotton-Fleece',
            '420 GSM Cotton-Fleece'
        ],
        minQuantity: 30,
        printingNote: 'Minimum order quantity is strictly 30 pieces.'
    }
};
const PRINTING_METHODS = [
    {
        id: 'dtf',
        name: 'DTF (Direct to Film)',
        description: 'Best for complicated/multi-colour designs',
        availableForAll: true,
        pricePerSide: 5.00,
        minQuantity: 30
    },
    {
        id: 'screen',
        name: 'Screen-Printing',
        description: 'Traditional method, best for bulk orders',
        pricePerColor: 1.00,
        minQuantity: 50
    },
    {
        id: 'hdpuff',
        name: 'HD/PUFF Printing',
        description: 'Creates raised, textured designs',
        pricePerColor: 2.50,
        minQuantity: 50
    },
    {
        id: 'embroidery',
        name: 'Embroidery',
        description: 'Premium finish with professional look',
        pricePerColor: 5.00,
        minQuantity: 50
    }
];

const PRODUCT_PRICES = {
    tshirts: {
        '220 GSM Cotton-Terry': {
            '100+': 13.50,
            '71-100': 14.50,
            '51-70': 15.50,
            '30-50': 16.50
        },
        '240 GSM Cotton-Terry': {
            '100+': 15.00,
            '71-100': 16.00,
            '51-70': 17.00,
            '30-50': 18.00
        },
        '240 GSM PC-Terry': {
            '100+': 14.00,
            '71-100': 15.00,
            '51-70': 16.00,
            '30-50': 17.00
        }
    },
    hoodies: {
        '350 GSM Cotton-Fleece': {
            '100+': 25.00,
            '71-100': 26.00,
            '51-70': 27.00,
            '30-50': 28.00
        },
        '420 GSM Cotton-Fleece': {
            '100+': 28.00,
            '71-100': 29.00,
            '51-70': 30.00,
            '30-50': 31.00
        }
    },
    quarterzips: {
        '350 GSM Cotton-Fleece': {
            '100+': 25.00,
            '71-100': 26.00,
            '51-70': 27.00,
            '30-50': 28.00
        },
        '420 GSM Cotton-Fleece': {
            '100+': 28.00,
            '71-100': 29.00,
            '51-70': 30.00,
            '30-50': 31.00
        }
    },
    zippers: {
        '350 GSM Cotton-Fleece': {
            '100+': 25.00,
            '71-100': 26.00,
            '51-70': 27.00,
            '30-50': 28.00
        },
        '420 GSM Cotton-Fleece': {
            '100+': 28.00,
            '71-100': 29.00,
            '51-70': 30.00,
            '30-50': 31.00
        }
    }
};
function initializeMerchandiseCalculator() {
    console.log('Initializing calculator...');
    const app = document.getElementById('merchandise-calculator-app');
    if (!app) {
        console.error('Calculator app element not found');
        return;
    }

    let formData = {
        productType: '',
        material: '',
        quantity: '',
        printingMethods: [],
        sides: 1,
        colors: 1,
        name: '',
        email: '',
        phone: '',
        businessType: '',
        additionalNotes: '',
        marketingConsent: false
    };

    function renderCalculator() {
        console.log('Rendering calculator...');
        app.innerHTML = `
            <div class="calculator-container">
                <div class="product-selection">
                    <h1 class="section-heading">Select Product Type</h1>
                    <div class="product-grid">
                        ${Object.entries(PRODUCTS).map(([key, product]) => `
                            <div class="product-card ${formData.productType === key ? 'selected' : ''}" 
                                data-product="${key}">
                                <div class="product-image-wrapper">
                                    <img src="${product.image}" alt="${product.name}" class="product-image">
                                </div>
                                <div class="product-details">
                                    <p class="vendor">${product.vendor}</p>
                                    <h2 class="product-title">${product.name}</h2>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                ${formData.productType ? getFormHTML() : ''}
            </div>
        `;

        setupEventListeners();
    }
  function getFormHTML() {
        return `
            <div class="calculator-form">
                <div class="form-card">
                    <form id="merchandise-form">
                        <div class="form-section">
                            <h2 class="form-section-title">Select Material</h2>
                            <div class="material-options">
                                ${PRODUCTS[formData.productType].materials.map(material => `
                                    <label class="option-label ${formData.material === material ? 'selected' : ''}">
                                        <input type="radio" name="material" value="${material}"
                                            ${formData.material === material ? 'checked' : ''}>
                                        <span>${material}</span>
                                    </label>
                                `).join('')}
                            </div>
                        </div>

                        <div class="form-section quantity-section">
                            <h2 class="form-section-title">Enter Quantity</h2>
                            <input type="number" 
                                name="quantity" 
                                class="quantity-input"
                                value="${formData.quantity}"
                                min="${PRODUCTS[formData.productType].minQuantity}"
                                placeholder="Minimum quantity ${PRODUCTS[formData.productType].minQuantity}"
                                step="1">
                            
                            ${formData.quantity ? `
                                <div class="quantity-note ${shouldShowQuantityWarning() ? 'warning' : ''}">
                                    ${getQuantityNote()}
                                </div>
                            ` : ''}
                        </div>

                        <div class="form-section">
                            <h2 class="form-section-title">Select Printing Method(s)</h2>
                            <div class="printing-methods">
                                ${PRINTING_METHODS.map(method => `
                                    <label class="option-label ${formData.printingMethods.includes(method.id) ? 'selected' : ''}
                                        ${shouldDisablePrintingMethod(method) ? 'disabled' : ''}">
                                        <input type="checkbox" 
                                            name="printingMethods" 
                                            value="${method.id}"
                                            ${formData.printingMethods.includes(method.id) ? 'checked' : ''}
                                            ${shouldDisablePrintingMethod(method) ? 'disabled' : ''}>
                                        <div class="method-info">
                                            <span class="method-name">${method.name}</span>
                                            <span class="method-description">${method.description}</span>
                                        </div>
                                    </label>
                                `).join('')}
                            </div>
                        </div>

                        <div class="form-section">
                            <h2 class="form-section-title">Contact Information</h2>
                            <div class="contact-form">
                                <div class="form-field">
                                    <label class="required">Name</label>
                                    <input type="text" name="name" value="${formData.name}" required>
                                </div>
                                <div class="form-field">
                                    <label class="required">Email</label>
                                    <input type="email" name="email" value="${formData.email}" required>
                                </div>
                                <div class="form-field">
                                    <label class="required">Phone</label>
                                    <input type="tel" name="phone" value="${formData.phone}" required>
                                </div>
                                <div class="form-field">
                                    <label>Business Type</label>
                                    <input type="text" name="businessType" value="${formData.businessType}">
                                </div>
                                <div class="form-field full-width">
                                    <label>Additional Notes</label>
                                    <textarea name="additionalNotes">${formData.additionalNotes}</textarea>
                                </div>
                            </div>

                            <div class="marketing-consent">
                                <label class="option-label">
                                    <input type="checkbox" name="marketingConsent" 
                                        ${formData.marketingConsent ? 'checked' : ''}>
                                    <span>I agree to receive marketing communications</span>
                                </label>
                            </div>

                            <button type="submit" class="submit-button" ${!isFormValid() ? 'disabled' : ''}>
                                Get Quote
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        `;
    }
  function setupEventListeners() {
        console.log('Setting up event listeners...');
        document.querySelectorAll('.product-card').forEach(card => {
            card.addEventListener('click', (e) => {
                const productKey = card.dataset.product;
                formData.productType = productKey;
                renderCalculator();
                setTimeout(() => {
                    const form = document.querySelector('.calculator-form');
                    if (form) {
                        const headerOffset = 100; // Adjust this value based on your header height
                        const formPosition = form.getBoundingClientRect().top;
                        const offsetPosition = formPosition + window.pageYOffset - headerOffset;

                        // Check if it's a mobile device
                        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                            // Mobile-specific scrolling
                            form.scrollIntoView({ behavior: 'auto', block: 'start' });
                            // Additional offset adjustment for mobile
                            window.scrollBy(0, -headerOffset);
                        } else {
                            // Desktop scrolling
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                            });
                        }
                    }
                }, 150); // Slightly increased delay for mobile devices
            });
        });

        const form = document.getElementById('merchandise-form');
        if (form) {
            form.querySelector('input[name="quantity"]')?.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.target.blur();
                }
            });

            form.addEventListener('change', (e) => {
                const input = e.target;
                
                if (input.name === 'quantity') {
                    handleQuantityChange(input);
                } else if (input.name === 'printingMethods') {
                    if (input.checked) {
                        formData.printingMethods.push(input.value);
                    } else {
                        formData.printingMethods = formData.printingMethods.filter(m => m !== input.value);
                    }
                    renderCalculator();
                } else if (input.type === 'checkbox') {
                    formData[input.name] = input.checked;
                    renderCalculator();
                } else {
                    formData[input.name] = input.value;
                    renderCalculator();
                }
            });

            form.addEventListener('submit', handleSubmit);
        }
    }

    function shouldShowQuantityWarning() {
        const quantity = parseInt(formData.quantity);
        if (!quantity) return false;
        
        if (formData.productType === 'tshirts') {
            return quantity >= 30 && quantity < 50;
        }
        return false;
    }

    function getQuantityNote() {
        const quantity = parseInt(formData.quantity);
        const product = PRODUCTS[formData.productType];
        
        if (!quantity) return '';
        
        if (formData.productType === 'tshirts') {
            if (quantity >= 30 && quantity < 50) {
                return product.printingNote;
            }
            if (quantity >= 50) {
                return 'Perfect! Your order qualifies for all available printing methods';
            }
        } else {
            if (quantity >= 30) {
                return 'Perfect! Your order qualifies for all available printing methods';
            }
        }
        return product.printingNote;
    }

    function shouldDisablePrintingMethod(method) {
        if (!formData.quantity) return true;
        const quantity = parseInt(formData.quantity);
        
        if (formData.productType === 'tshirts') {
            if (quantity >= 30 && quantity < 50) {
                return method.id !== 'dtf';
            }
            return quantity < method.minQuantity;
        }
        
        return quantity < PRODUCTS[formData.productType].minQuantity;
    }
  function handleQuantityChange(input) {
        const value = parseInt(input.value) || '';
        const productType = formData.productType;
        const minQuantity = PRODUCTS[productType].minQuantity;

        if (value && value < minQuantity) {
            showMinimumOrderPopup(minQuantity);
            input.value = minQuantity;
            formData.quantity = minQuantity;
        } else {
            formData.quantity = value;
        }

        renderCalculator();

        if (value) {
            const quantityNote = document.querySelector('.quantity-note');
            if (quantityNote) {
                const offset = 150;
                const elementPosition = quantityNote.getBoundingClientRect().bottom;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }

    function showMinimumOrderPopup(minQuantity) {
        const existingPopup = document.querySelector('.popup-overlay');
        if (existingPopup) {
            existingPopup.remove();
        }

        const message = formData.productType === 'tshirts' 
            ? `The minimum order quantity for t-shirts is ${minQuantity} pieces.`
            : `The minimum order quantity for this product is strictly ${minQuantity} pieces.`;

        const popup = document.createElement('div');
        popup.className = 'popup-overlay';
        popup.innerHTML = `
            <div class="popup-content">
                <h3>Minimum Order Requirement</h3>
                <p>${message}</p>
                <button type="button">OK</button>
            </div>
        `;

        document.body.appendChild(popup);

        const closePopup = () => popup.remove();
        popup.querySelector('button').addEventListener('click', closePopup);
        popup.addEventListener('click', e => {
            if (e.target === popup) closePopup();
        });
    }
function showSuccessPopup(email) {
    const existingPopup = document.querySelector('.popup-overlay');
    if (existingPopup) {
        existingPopup.remove();
    }

    const popup = document.createElement('div');
    popup.className = 'popup-overlay';
    popup.innerHTML = `
        <div class="popup-content">
            <h3>Quote Sent!</h3>
            <p>Please check your email:</p>
            <p style="font-weight: 500; margin: 8px 0;">${email}</p>
            <button type="button">Close</button>
        </div>
    `;

    document.body.appendChild(popup);

    const closePopup = () => {
        popup.style.opacity = '0';
        setTimeout(() => {
            popup.remove();
            // Reset form and scroll to top after closing popup
            resetForm();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
    };

    popup.querySelector('button').addEventListener('click', closePopup);
    popup.addEventListener('click', e => {
        if (e.target === popup) closePopup();
    });
}
    function calculatePrice() {
        const quantity = parseInt(formData.quantity);
        let priceRange;
        
        if (quantity >= 100) priceRange = '100+';
        else if (quantity >= 71) priceRange = '71-100';
        else if (quantity >= 51) priceRange = '51-70';
        else priceRange = '30-50';

        console.log('Price calculation:', {
        productType: formData.productType,
        material: formData.material,
        priceRange: priceRange,
        quantity: quantity
    });
      
        const basePrice = PRODUCT_PRICES[formData.productType][formData.material][priceRange] || 0;
        
        let printingCost = 0;
        formData.printingMethods.forEach(methodId => {
            const method = PRINTING_METHODS.find(m => m.id === methodId);
            if (method) {
                if (method.id === 'dtf') {
                    printingCost += method.pricePerSide * formData.sides;
                } else {
                    printingCost += method.pricePerColor * formData.colors;
                }
            }
        });
        
        const totalPricePerUnit = basePrice + printingCost;
        const totalPrice = totalPricePerUnit * quantity;
        const gst = totalPrice * 0.10; // Calculate 10% GST
        const totalWithGst = totalPrice + gst; // Add GST to total
        // Add debug log
    console.log('Final price calculation:', {
        basePrice,
        printingCost,
        totalPricePerUnit,
        totalPrice,
        gst,
        totalWithGst
    });
        return {
            basePrice,
            printingCost,
            totalPricePerUnit,
            totalPrice,
            gst,
            totalWithGst,
            quantity
        };
    }

    function isFormValid() {
        if (!formData.productType || !formData.material || !formData.printingMethods.length) {
            return false;
        }

        const quantity = parseInt(formData.quantity);
        const minQuantity = PRODUCTS[formData.productType].minQuantity;
        if (!quantity || quantity < minQuantity) {
            return false;
        }

        return formData.name && formData.email && formData.phone;
    }
  function showAlert(message, type) {
        const alertDiv = document.createElement('div');
        alertDiv.className = `alert ${type}`;
        
        const icon = type === 'success' ? '✓' : '⚠';
        
        alertDiv.innerHTML = `
            <span class="alert-icon">${icon}</span>
            <span class="alert-message">${message}</span>
        `;
        
        const form = document.querySelector('.form-card');
        form.insertBefore(alertDiv, form.firstChild);
        
        alertDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        setTimeout(() => {
            alertDiv.style.opacity = '0';
            setTimeout(() => alertDiv.remove(), 300);
        }, 5000);
    }

    function resetForm() {
        formData = {
            productType: '',
            material: '',
            quantity: '',
            printingMethods: [],
            sides: 1,
            colors: 1,
            name: '',
            email: '',
            phone: '',
            businessType: '',
            additionalNotes: '',
            marketingConsent: false
        };
        renderCalculator();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

function handleSubmit(e) {
    e.preventDefault();
    
    if (!isFormValid()) {
        showAlert('Please fill in all required fields', 'error');
        return;
    }

    const pricing = calculatePrice();
    const submitButton = e.target.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Processing...';

    // Format the printing methods
    const printingMethodsText = formData.printingMethods
        .map(id => PRINTING_METHODS.find(m => m.id === id).name)
        .join(', ');

    // Generate printing details text
    let printingDetails = formData.printingMethods.map(methodId => {
        const method = PRINTING_METHODS.find(m => m.id === methodId);
        if (method.id === 'dtf') {
            return `DTF Printing: $${method.pricePerSide} × ${formData.sides} sides`;
        } else {
            return `${method.name}: $${method.pricePerColor} × ${formData.colors} colors`;
        }
    }).join('\n');

    // If no printing details, provide a default message
    if (!printingDetails) {
        printingDetails = 'Standard printing included';
    }

    // Clean up optional fields
    const additionalNotes = formData.additionalNotes?.trim() || 'No additional notes provided';

    // Prepare template parameters
    const templateParams = {
        to_name: formData.name,
        from_name: "ZERO TO ONE STORE",
        customer_email: formData.email,
        phone: formData.phone,
        product_type: PRODUCTS[formData.productType].name,
        material: formData.material,
        quantity: formData.quantity,
        printing_methods: printingMethodsText,
        base_price: pricing.basePrice.toFixed(2),
        printing_cost: pricing.printingCost.toFixed(2),
        printing_details: printingDetails,
        price_per_unit: pricing.totalPricePerUnit.toFixed(2),
        total_price: pricing.totalPrice.toFixed(2),
        gst: pricing.gst.toFixed(2),
        total_with_gst: pricing.totalWithGst.toFixed(2),
        additional_notes: additionalNotes
    };

    console.log('Sending emails with params:', templateParams);

    // Send customer email first
    emailjs.send("service_61myts7", "template_decdemk", templateParams)
        .then(function(response) {
            console.log("Customer email sent:", response);
            
            // Then send admin notification
            return emailjs.send("service_61myts7", "template_em9g41r", templateParams);
        })
        .then(function(response) {
            console.log("Admin notification sent:", response);
            showSuccessPopup(formData.email);
        })
        .catch(function(error) {
            console.error("FAILED...", error);
            showAlert('Error sending email: ' + error.text, 'error');
        })
        .finally(function() {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
        });
}

    // Initialize the calculator
    console.log('Starting initial render...');
    renderCalculator();
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, starting calculator initialization...');
    try {
        initializeMerchandiseCalculator();
    } catch (error) {
        console.error('Calculator initialization error:', error);
    }
});